
//*****************************************************************
//**************************** import *****************************
//*****************************************************************
// import * as bootstrap from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
// or, specify which plugins you need:
//import { Tooltip, Toast, Popover, Modal } from 'bootstrap';
import { Modal, Tooltip } from 'bootstrap';
window.Modal = Modal; // Espone Modal globalmente

import Cleave from 'cleave.js';
require('cleave.js/dist/addons/cleave-phone.it');
//import path from '/_common/prefix.json';

import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// specify which plugins you need:
// import { Navigation, Pagination, Autoplay, A11y, EffectFade, Autoplay} from 'swiper/modules';
import { Navigation, Pagination, A11y } from 'swiper/modules';

import EnergySaver from './js/vendors/energy-saver';

import AOS from 'aos';

import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core' // ref: https://zxcvbn-ts.github.io/zxcvbn/guide/getting-started/
//import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common'
//import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en'

document.addEventListener("DOMContentLoaded", () => {
	
});

//*****************************************************************
//************************ function *******************************
//*****************************************************************

// Tooltip
export function initTooltips() {
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new Tooltip(tooltipTriggerEl, {
			offset: [0, 5],
			trigger: 'manual',
			html: true
		});
	});
}

// Copia il testo fornito negli appunti e mostra tooltip di conferma
export async function copyCode(elm, code) {
	try {
		await navigator.clipboard.writeText(code);
		const tooltipInstance = Tooltip.getInstance(elm);
		if (tooltipInstance) {
			tooltipInstance.show();
			setTimeout(() => tooltipInstance.hide(), 2000);
		}
	} catch (error) {
		alert(error.message);
	}
}

// Fix CookieScript accessibilità, aria-label di Cookie Script
const onElementAdded = (id, callback) => {
	const targetNode = document.body;
	const config = { childList: true, subtree: true };
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === "childList") {
				const el = document.getElementById(id);
				if (el) {
					callback(el);
					observer.disconnect();
					break;
				}
			}
		}
	});
	observer.observe(targetNode, config);
};
export function initCookieScriptAccessibility() {
	window.addEventListener("CookieScriptLoaded", function () {
		const cookiescript_badge = document.getElementById("cookiescript_badge");
		cookiescript_badge?.setAttribute("aria-label", "Gestione preferenze cookie");

		onElementAdded("cookiescript_injected_wrapper", function (cookiescript_injected_wrapper) {
			const cookiescript_badge = cookiescript_injected_wrapper?.querySelector("#cookiescript_badge");
			cookiescript_badge?.setAttribute("aria-label", "Gestione preferenze cookie");

			const cookiescript_close = cookiescript_injected_wrapper?.querySelector("#cookiescript_close");
			cookiescript_close?.setAttribute("aria-label", "Chiudi la finestra di dialogo dei cookie");

			const cookiescript_readmore = cookiescript_injected_wrapper?.querySelector("#cookiescript_readmore");
			cookiescript_readmore?.setAttribute("aria-label", "Leggi di più (apre una nuova scheda)");
		});
	});
}

// Swiper // Inizializza uno slider Swiper se presente in pagina
export function initSwiper() {
	const swiperElm = document.querySelector('.my--swiper');
	if (!swiperElm) {
		return;
	}

	// Traduzioni per l'accessibilità (A11y) di Swiper in italiano
	 const swiperTranslations = {
	     firstSlideMessage: `Questa è la prima slide`,
	     lastSlideMessage: `Questa è l'ultima slide`,
	     nextSlideMessage: `Vai alla prossima slide`,
	     paginationBulletMessage: `Vai alla slide {{index}}`,
	     prevSlideMessage: `Vai alla slide precedente`,
	     slideLabelMessage: `{{index}} di {{slidesLength}}`
	 }

	// Impostazioni per l'istanza Swiper
	const swiperArgs = {
		// Moduli Swiper importati (es. con import { Navigation, Pagination, A11y } from 'swiper/modules';)
		modules: [Navigation, Pagination, A11y],

		// Accessibilità
		a11y: swiperTranslations,

		// Non cicla le slide (no loop infinito)
		loop: false,

		// Inizializzazione manuale (chiameremo noi .init())
		init: false,

		// Classe CSS personalizzata per le singole slide
		slideClass: 'my--slide',

		// Configurazione dei puntini di paginazione
		pagination: {
			el: '.my--pagination',
			clickable: true, // consente cliccare sui pallini per cambiare slide
		},

		// Pulsanti di navigazione avanti/indietro
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// Breakpoint responsive per numero di slide visibili e spaziatura
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 10
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			}
		}
	};

	// Crea l'istanza Swiper con i parametri definiti
	let mySwiper = new Swiper(swiperElm, swiperArgs);

	// Evento personalizzato da eseguire all'inizializzazione
	mySwiper.on('init', function (e) {
		if (e.slides.length > 1) {
			// Se ci sono più di una slide, potresti applicare una classe aggiuntiva per margini o layout
			// swiperElm.classList.add("margined-left");
		}
	});

	// Inizializza Swiper manualmente (dato che init: false)
	mySwiper.init();
}

// Cleavejs // Inizializza i formati automatici sugli input tramite Cleave.js
export function initCleave() {
	// 📅 Data di nascita - formato data (gg/mm/aaaa)
	const datanascita = document.querySelector('#Input_DataNascita');
	if (datanascita) {
		new Cleave(datanascita, {
			date: true,
			blocks: [10], // lunghezza complessiva
			datePattern: ['d', 'm', 'Y'] // formato giorno/mese/anno
		});
	}

	// 📍 CAP - solo numeri, 5 cifre
	const cap = document.querySelector('#Input_Cap');
	if (cap) {
		new Cleave(cap, {
			blocks: [5],
			numericOnly: true
		});
	}

	// 📞 Telefono - formato telefonico italiano, massimo 15 cifre, senza separatori
	const telefono = document.querySelector('#Input_Cellulare');
	if (telefono) {
		new Cleave(telefono, {
			phone: true,
			phoneRegionCode: 'it',
			blocks: [15],
			numericOnly: true,
			delimiter: ''
		});
	}

	// 🆔 Codice fiscale - 16 caratteri alfanumerici, tutti maiuscoli
	const codicefiscale = document.querySelector('#Input_CodiceFiscale');
	if (codicefiscale) {
		new Cleave(codicefiscale, {
			blocks: [16],
			uppercase: true
		});
	}

	// 🧾 Partita IVA - 11 cifre numeriche
	const partitaiva = document.querySelector('#Input_PartitaIva');
	if (partitaiva) {
		new Cleave(partitaiva, {
			blocks: [11],
			numericOnly: true
		});
	}

	// *** SCONTRINO
	// 📆 Data scontrino - formato data (gg/mm/aaaa)
	// Seleziona tutti gli input che terminano con 'DataAcquisto'
	const dataAcquistoInputs = document.querySelectorAll('input[id$="DataAcquisto"]');
	if (dataAcquistoInputs.length > 0) {
		dataAcquistoInputs.forEach(input => {
			new Cleave(input, {
				date: true,
				delimiter: '/',
				datePattern: ['d', 'm', 'Y']
			});
		});
	}
	// Singolo campo
	// 📆 Data scontrino - formato data (gg/mm/aaaa)
	//const datascontrino = document.querySelector('#Input_DataAcquisto');
	//if (datascontrino) {
	//	new Cleave(datascontrino, {
	//		date: true,
	//		delimiter: '/', // separatore tra gg/mm/aaaa
	//		datePattern: ['d', 'm', 'Y']
	//	});
	//}

	// 🕒 Orario scontrino - formato ora (hh:mm)
	// Seleziona tutti gli input che terminano con 'OrarioAcquisto'
	const orarioAcquistoInputs = document.querySelectorAll('input[id$="OrarioAcquisto"]');
	if (orarioAcquistoInputs.length > 0) {
		orarioAcquistoInputs.forEach(input => {
			new Cleave(input, {
				time: true,
				delimiter: ':',
				timePattern: ['h', 'm']
			});
		});
	}

	// singolo campo
	//const orarioscontrino = document.querySelector('#Input_OrarioAcquisto');
	//if (orarioscontrino) {
	//	new Cleave(orarioscontrino, {
	//		time: true,
	//		delimiter: ':',
	//		timePattern: ['h', 'm']
	//	});
	//}

	// 🧾 Numero scontrino/acquisto - formato con due blocchi di 4 cifre separati da trattino (es. 1234-5678)
	const numeroAcquistoInputs = Array.from(document.querySelectorAll('input[id$="NumeroAcquisto"]'))
		.filter(input => input.id !== 'InputFattura_NumeroAcquisto');
	if (numeroAcquistoInputs.length > 0) {
		numeroAcquistoInputs.forEach(input => {
			new Cleave(input, {
				blocks: [4, 4],
				delimiter: '-',
				numericOnly: true
			});
		});
	}
	// singolo campo
	// 🧾 Numero scontrino/acquisto - formato con due blocchi di 4 cifre separati da trattino (es. 1234-5678)
	// const numeroscontrino = document.querySelector('#Input_NumeroAcquisto');
	// if (numeroscontrino) {
	// 	new Cleave(numeroscontrino, {
	// 		blocks: [4, 4],
	// 		delimiter: '-',
	// 		numericOnly: true
	// 	});
	// }

	// 💶 Importo scontrino/acquisto - numerico con 2 decimali, virgola come separatore decimale
	const importoAcquistoInputs = document.querySelectorAll('input[id$="ImportoAcquisto"]');
	if (importoAcquistoInputs.length > 0) {
		importoAcquistoInputs.forEach(input => {
			new Cleave(input, {
				blocks: [6], // numero massimo di cifre prima del separatore
				numeral: true,
				delimiter: '', // niente separatore per le migliaia
				numeralDecimalScale: 2, // due cifre decimali
				numeralDecimalMark: ',', // separatore decimale (virgola per lo stile italiano)
			});
		});
	}

	// singolo campo
	// 💶 Importo scontrino - numerico con 2 decimali, virgola come separatore decimale
	// const importoscontrino = document.querySelector('#Input_ImportoAcquisto');
	// if (importoscontrino) {
	// 	new Cleave(importoscontrino, {
	// 		blocks: [6], // numero massimo di cifre prima del separatore
	// 		numeral: true,
	// 		delimiter: '', // niente separatore per le migliaia
	// 		numeralDecimalScale: 2, // due cifre decimali
	// 		numeralDecimalMark: ',', // separatore decimale (virgola per lo stile italiano)
	// 	});
	// }
}

// EnergySaver // Inizializza il modulo EnergySaver per ridurre l'impatto energetico del sito
export function initEnergySaver() {
	const energyS = new EnergySaver({
		idle: 300000, // ⚡ Tempo di inattività (30 secondi) dopo il quale attivare la modalità "risparmio energia"
		enableZeroImpact: false, // ✅ Abilita la modalità "Zero Impact" per ridurre il consumo energetico
		enableZeroImpactTarget: "#zeroimpact", // 🎯 Selettore del contenitore DOM da aggiornare quando la modalità è attiva
		enableCredits: true // 🙌 Mostra i crediti dell'autore/plugin (utile per attribuzione)
	});
}

// Show Loading // Mostra una schermata di caricamento con spinner e opacità animata
export function showLoading(hide, event) {
	if (event) {
		event.preventDefault(); // ❌ Previene l'azione predefinita (es. invio form o click su link)
	}

	// 🌀 Crea il contenitore del loader
	var loadingPage = document.createElement("div");
	document.body.prepend(loadingPage); // Inserisce il loader all'inizio del body
	loadingPage.classList.add("page-loader"); // Aggiunge classe CSS per stile
	loadingPage.style.opacity = 0; // Inizia con opacità 0

	// 🎯 Inserisce spinner + testo accessibile
	loadingPage.innerHTML = `
		<span class="spinner-border" role="status"></span>
		<span class="text-muted visually-hidden">Loading page...</span>
	`;

	// 🔁 Funzione interna per animare l'opacità (fade-in)
	function fadeIn(el, time) {
		el.style.opacity = 0;
		let last = +new Date();
		let tick = function () {
			// Incrementa l'opacità progressivamente
			el.style.opacity = +el.style.opacity + (new Date() - last) / time;
			last = +new Date();
			if (+el.style.opacity < 1) {
				(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
			}
		};
		tick();
	}

	// ⚙️ Avvia animazione fade-in con durata di 250ms
	fadeIn(loadingPage, 250);

	// ⏳ Se richiesto, nasconde il loader dopo 5 secondi
	if (hide) {
		setTimeout(function () {
			hideLoading(); // Presuppone che una funzione hideLoading() sia definita altrove
		}, 5000);
	}
}

// Hide Loading // Nasconde la schermata di caricamento con un effetto di fade-out
export function hideLoading() {
	// Seleziona l'elemento loader presente nel DOM
	var loadingPage = document.querySelector(".page-loader");
	if (!loadingPage) return;

	// Funzione interna per animare il fade-out (opacità da 1 a 0)
	function fadeOut(el, time) {
		el.style.opacity = 1; // Imposta opacità iniziale a 1 (visibile)
		let last = +new Date();

		let tick = function () {
			// Riduce progressivamente l'opacità in base al tempo trascorso
			el.style.opacity = +el.style.opacity - (new Date() - last) / time;
			last = +new Date();

			if (+el.style.opacity > 0) {
				// Continua l'animazione usando requestAnimationFrame o fallback a setTimeout
				(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
			} else {
				// Al termine dell'animazione rimuove l'elemento dal DOM
				loadingPage.remove();
			}
		};
		tick();
	}

	// Avvia l'animazione di fade-out con durata 250ms
	fadeOut(loadingPage, 250);
};

// Menu Focus Trap // Imposta un focus trap nel menu (header) per mantenere il focus all'interno quando nav è attivo
export function initMenuFocusTrap() {

	// Selettore per tutti gli elementi che possono ricevere focus dentro il menu
	const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([data-focusable="-1"])';

	// Target del focus trap, qui il header (menu)
	const targetItem = document.querySelector('header');

	// Primo elemento focusabile all'interno del target
	const firstFocusableElement = targetItem.querySelectorAll(focusableElements)[0];

	// Tutti gli elementi focusabili dentro il target (header)
	const focusableContent = targetItem.querySelectorAll(focusableElements);

	// Gestore globale del keydown per catturare il tab/shift+tab
	document.addEventListener('keydown', function (e) {
		// Filtra gli elementi focusabili per quelli visibili (offsetParent != null)
		var visibleButtons = [];
		focusableContent.forEach(element => {
			if (element.offsetParent != null) {
				visibleButtons.push(element);
			}
		});

		// Ultimo elemento focusabile visibile
		const lastFocusableElement = visibleButtons[visibleButtons.length - 1];

		// Solo se il menu è aperto (body ha classe nav-is-active)
		if (document.querySelector('body').classList.contains('nav-is-active')) {

			// Controlla se è stato premuto il tasto Tab
			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

			if (!isTabPressed) {
				return; // Ignora altri tasti
			}

			if (e.shiftKey) { // Shift + Tab (tab indietro)
				if (document.activeElement === firstFocusableElement) {
					// Se si è sul primo elemento, sposta il focus sull'ultimo (loop inverso)
					lastFocusableElement.focus();
					e.preventDefault(); // Blocca il comportamento di default per evitare uscita dal focus trap
				}
			} else { // Tab normale
				if (document.activeElement === lastFocusableElement) {
					// Se si è sull'ultimo elemento, torna al primo (loop avanti)
					firstFocusableElement.focus();
					e.preventDefault();
				}
			}
		}
	});
}

// set Focus On Element // Imposta il focus sul primo elemento focusabile all'interno del target fornito
export function setFocusOnElement(target) {
	// Seleziona tutti gli elementi che possono ricevere focus dentro target,
	// escludendo quelli con data-focusable="-1" (non focusabili)
	var focusable = target.querySelectorAll(
		'input:not([data-focusable="-1"]), ' +
		'select:not([data-focusable="-1"]), ' +
		'textarea:not([data-focusable="-1"]), ' +
		'button:not([data-focusable="-1"]), ' +
		'[href]:not([data-focusable="-1"]), ' +
		'[tabindex]:not([data-focusable="-1"])'
	);

	// Prende il primo elemento focusabile trovato
	var firstFocusable = focusable[0];

	// Se esiste un elemento focusabile, gli assegna il focus
	if (firstFocusable) {
		firstFocusable.focus();
	}
}

// Password strength bar // Aggiorna la barra della forza password in base al punteggio
function updatePasswordStrengthBar(score) {
	// Recupera il contenitore della barra e la barra stessa
	const container = document.getElementById('password-strength-bar-container');
	const bar = document.getElementById('password-strength-bar');

	// Rende visibile il contenitore e aggiorna l'accessibilità
	container.classList.remove('hidden');
	container.setAttribute('aria-hidden', 'false');

	// Valori iniziali
	let width = '0%';
	let color = '#ccc';

	// Imposta larghezza e colore in base al punteggio
	switch (score) {
		case 0:
			width = '0%';
			color = '#ccc'; // gray
			break;
		case 1:
			width = '25%';
			color = '#dc2626'; // rosso
			break;
		case 2:
			width = '50%';
			color = '#facc15'; // giallo
			break;
		case 3:
			width = '75%';
			color = '#4ade80'; // verde chiaro
			break;
		case 4:
			width = '100%';
			color = '#16a34a'; // verde intenso
			break;
	}

	// Applica larghezza e colore alla barra
	bar.style.width = width;
	bar.style.backgroundColor = color;
}

// Validators form // Valida e gestisce tutti i campi di una form
export function initFormValidation() {

	const forms = document.querySelectorAll('.needs-validation'); // Seleziona tutti i form con classe needs-validation

	if (forms) {

		// ✅ Mostra o nasconde il feedback visivo di errore per un input
		function showHideFeedback(elm, valid) {
			const wrap = elm.closest('.wrap-input');
			if (!wrap) return;
			const container = wrap.closest('.input-group') || wrap.parentElement;
			if (!container) return;
			const feedback = container.querySelector('.invalid-feedback');
			if (!feedback) return;
			const inputGroup = feedback.closest('.input-group');

			if (!valid) {
				// Applica classe di errore visivo all'input e ai suoi elementi associati
				elm.classList.add('is-invalid');
				feedback.classList.add('is-invalid');

				if (inputGroup) {
					let inputGroupText = inputGroup.querySelector('.input-group-text');
					inputGroupText.classList.add("is-invalid");
				}
			} else {
				// Rimuove classe di errore visivo se valido
				elm.classList.remove('is-invalid');
				feedback.classList.remove('is-invalid');

				if (inputGroup) {
					let inputGroupText = inputGroup.querySelector('.input-group-text');
					inputGroupText.classList.remove("is-invalid");
				}
			}
		}

		// ✅ Verifica se una data è passata, valida e opzionalmente entro un limite di anni
		function isValidPastDate(dateStr, { allowFuture = false, maxPastYears = null } = {}) {
			const parts = dateStr.split('/');
			if (parts.length !== 3) return false;

			const day = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1;
			const year = parseInt(parts[2], 10);

			const date = new Date(year, month, day);
			if (isNaN(date.getTime())) return false;

			// Confronta data generata con input per verificarne la coerenza
			if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
				return false;
			}

			const today = new Date();
			today.setHours(0, 0, 0, 0);

			const inputDate = new Date(date.getTime());
			inputDate.setHours(0, 0, 0, 0);

			// Blocca date future se non permesse
			if (!allowFuture && inputDate.getTime() > today.getTime()) {
				return false;
			}

			// Blocca date troppo vecchie se richiesto
			if (maxPastYears !== null) {
				const oldestAllowed = new Date(today.getFullYear() - maxPastYears, today.getMonth(), today.getDate());
				oldestAllowed.setHours(0, 0, 0, 0);
				if (inputDate.getTime() < oldestAllowed.getTime()) {
					return false;
				}
			}

			return true;
		}

		// ✅ Applica messaggi di errore personalizzati per ciascun campo in base alla validità
		function setFeedback(id, elm) {
			const invalidField = elm;

			// *** REGISTRAZIONE
			// Controlli specifici per i campi del form di registrazione

			// 📅 Data di nascita: controlla formato, esistenza, validità temporale
			if (id === 'Input_DataNascita') {
				const errorSpan = document.getElementById('invalidDataNascita');
				if (!errorSpan) return;
				const value = invalidField.value;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare la data di nascita';
					invalidField.setCustomValidity('Digitare la data di nascita');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato data non valido';
					invalidField.setCustomValidity('Formato data non valido');
				} else if (!isValidPastDate(value, { allowFuture: false, maxPastYears: 100 })) {
					errorSpan.textContent = 'Data non valida';
					invalidField.setCustomValidity('Data non valida');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// ☎️ Telefono: controlla presenza e formato minimo
			if (id === 'Input_Cellulare') {
				const errorSpan = document.getElementById('invalidCellulare');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare il numero di telefono';
					invalidField.setCustomValidity('Digitare il numero di telefono');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Inserire minimo 6 cifre';
					invalidField.setCustomValidity('Inserire minimo 6 cifre');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 👤 Codice fiscale: presenza e formato
			if (id === 'Input_CodiceFiscale') {
				const errorSpan = document.getElementById('invalidCodiceFiscale');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare il codice fiscale';
					invalidField.setCustomValidity('Digitare il codice fiscale');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato codice non valido';
					invalidField.setCustomValidity('Formato codice non valido');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 📧 Email: formato e verifica con conferma
			if (id === 'Input_Email') {
				const errorSpan = document.getElementById('invalidEmail');
				if (!errorSpan) return;
				const emailValue = invalidField.value;
				const confermaEmailInput = document.getElementById('Input_ConfermaEmail');

				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare l’e-mail';
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato e-mail non valido';
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}

				// Verifica corrispondenza con campo conferma
				if (confermaEmailInput && confermaEmailInput.value != '') {
					if (emailValue !== confermaEmailInput.value) {
						invalidField.setCustomValidity('Le e-mail non coincidono');
						errorSpan.textContent = 'Le e-mail non coincidono';
						errorSpan.style.display = "block";
					} else {
						invalidField.setCustomValidity('');
						errorSpan.textContent = '';
						errorSpan.style.display = "none";
					}
				}
			}

			// 📧 Conferma email: stesso controllo del campo principale + confronto
			if (id === 'Input_ConfermaEmail') {
				const errorSpan = document.getElementById('invalidConfermaEmail');
				if (!errorSpan) return;
				const emailValue = document.getElementById('Input_Email').value;
				const confermaEmailValue = invalidField.value;

				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare l’e-mail';
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato e-mail non valido';
				} else if (emailValue != confermaEmailValue) {
					errorSpan.textContent = 'Le e-mail non coincidono';
					invalidField.setCustomValidity('Le e-mail non coincidono');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 🔒 Password: formato e verifica con conferma
			if (id === 'Input_Password') {
				const errorSpan = document.getElementById('invalidPassword');
				if (!errorSpan) return;
				const passwordValue = invalidField.value;
				const confermaPasswordInput = document.getElementById('Input_ConfermaPassword');

				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare la password';
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato password errato';
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}

				// Verifica corrispondenza con conferma
				if (confermaPasswordInput && confermaPasswordInput.value !== '') {
					if (passwordValue !== confermaPasswordInput.value) {
						invalidField.setCustomValidity('Le password non coincidono');
						errorSpan.textContent = 'Le password non coincidono';
						errorSpan.style.display = 'block';
					} else {
						invalidField.setCustomValidity('');
						errorSpan.textContent = '';
						errorSpan.style.display = "none";
					}
				}

				// Verifica la forza della password (il campo deve avere la classe "strength")
				const element = document.getElementById(id);
				if (element.classList.contains("strength")) {
					const passwordValue = element.value;
					const result = zxcvbn(passwordValue);
					updatePasswordStrengthBar(result.score);
				}
			}

			// 🔒 Conferma Password: confronta con password principale solo se questa è valida
			if (id === 'Input_ConfermaPassword') {
				const errorSpan = document.getElementById('invalidConfermaPassword');
				if (!errorSpan) return;
				const passwordInput = document.getElementById('Input_Password');
				const passwordValue = passwordInput ? passwordInput.value : '';
				const confermaPasswordValue = invalidField.value;

				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare la conferma password';
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato password errato';
				}
				else if (!passwordInput.checkValidity()) {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
				else if (passwordValue !== confermaPasswordValue) {
					errorSpan.textContent = 'Le password non coincidono';
					invalidField.setCustomValidity('Le password non coincidono');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 🏢 Partita IVA: controlli di base
			if (id === 'Input_PartitaIva') {
				const errorSpan = document.getElementById('invalidPartitaIva');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare la partita Iva';
					invalidField.setCustomValidity('Digitare la partita Iva');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato codice non valido';
					invalidField.setCustomValidity('Formato codice non valido');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 🔘 Checkbox privacy obbligatoria
			if (id === 'Input_Privacy1') {
				const errorSpan = document.getElementById('InvalidPrivacy1');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Campo obbligatorio';
					invalidField.setCustomValidity('Campo obbligatorio');
				}
				else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 🔘 Radio privacy obbligatoria: deve essere selezionato il valore "si"
			if (id === 'Input_Privacy2_si' || id === 'Input_Privacy2_no') {
				const errorSpan = document.getElementById('invalidPrivacy2');
				if (!errorSpan) return;
				const radios = document.querySelectorAll('input[name="Input.Privacy2"]');
				const siSelected = Array.from(radios).some(r => r.value === 'si' && r.checked);
				if (!siSelected) {
					errorSpan.textContent = 'Campo obbligatorio';
					errorSpan.style.display = 'block';
					radios.forEach(r => r.setCustomValidity('Devi accettare la privacy'));
				} else {
					errorSpan.textContent = '';
					errorSpan.style.display = 'none';
					radios.forEach(r => r.setCustomValidity(''));
				}
			}

			// *** SCONTRINO / FATTURA
			// Controlli specifici per i campi di scontrino/fattura

			// 📅 Data acquisto: controlla formato, esistenza, validità temporale
			if (id === 'Input_DataAcquisto' || id === 'InputScontrino_DataAcquisto' || id === 'InputFattura_DataAcquisto') {
				const errorSpan = document.getElementById('invalidDataAcquisto');
				if (!errorSpan) return;
				const value = invalidField.value;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare la data di acquisto';
					invalidField.setCustomValidity('Digitare la data di acquisto');
				} else if (invalidField.validity.patternMismatch) {
					const today = new Date();
					const todayStr = today.toLocaleDateString('it-IT');
					errorSpan.textContent = `Formato data non valido (es: ${todayStr})`;
					invalidField.setCustomValidity(`Formato data non valido (es: ${todayStr})`);
				} else if (!isValidPastDate(value, { allowFuture: false, maxPastYears: 1 })) {
					errorSpan.textContent = 'Data non valida o non realistica';
					invalidField.setCustomValidity('Data non valida o non realistica');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}	
			}

			// 🕒 Orario acquisto
			if (id === 'Input_OrarioAcquisto' || id === 'InputScontrino_OrarioAcquisto' || id === 'InputFattura_OrarioAcquisto') {
				const errorSpan = document.getElementById('invalidOrarioAcquisto');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare l’orario di acquisto';
					invalidField.setCustomValidity('Digitare l’orario di acquisto');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato orario non valido (es. 14:30)';
					invalidField.setCustomValidity('Formato orario non valido (es. 14:30)');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 🧾 Numero acquisto
			if (id === 'Input_NumeroAcquisto' || id === 'InputScontrino_NumeroAcquisto') {
				const errorSpan = document.getElementById('invalidNumeroAcquisto');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare il numero di acquisto';
					invalidField.setCustomValidity('Digitare il numero di acquisto');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato numero non valido (es: 1234-5678)';
					invalidField.setCustomValidity('Formato numero non valido (es: 1234-5678)');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}

			// 💶 Importo acquisto
			if (id === 'Input_ImportoAcquisto' || id === 'InputScontrino_ImportoAcquisto' || id === 'InputFattura_ImportoAcquisto') {
				const errorSpan = document.getElementById('invalidImportoAcquisto');
				if (!errorSpan) return;
				if (invalidField.validity.valueMissing) {
					errorSpan.textContent = 'Digitare l’importo di acquisto';
					invalidField.setCustomValidity('Digitare l’importo di acquisto');
				} else if (invalidField.validity.patternMismatch) {
					errorSpan.textContent = 'Formato non valido (es: 10,99)';
					invalidField.setCustomValidity('Formato non valido (es: 10,99)');
				} else {
					errorSpan.textContent = '';
					invalidField.setCustomValidity('');
				}
			}
		}

		// ✅ Aggiunge eventi di validazione in tempo reale agli input
		Array.from(forms).forEach(form => {
			let allInputs = form.querySelectorAll('input, select, textarea');

			allInputs.forEach(function (el) {
				let eventType = 'input'; // default

				// Usa change per checkbox, radio e select
				if (el.type === 'checkbox' || el.type === 'radio' || el.tagName === 'SELECT') {
					eventType = 'change';
				}

				el.addEventListener(eventType, function () {
					const id = el.getAttribute('id');

					// 🔠 Forza il codice fiscale in maiuscolo
					if (id === 'Input_CodiceFiscale') {
						this.value = this.value.toUpperCase();
					}

					setFeedback(id, el); // Applica feedback personalizzato

					// Aggiorna visibilità del feedback
					if (el.checkValidity()) {
						el.removeAttribute('aria-invalid');
						if (form.classList.contains('was-validated')) {
							showHideFeedback(el, true);
						}
					} else {
						el.setAttribute('aria-invalid', 'true');
						if (form.classList.contains('was-validated')) {
							showHideFeedback(el, false);
						}
					}
				});
			});

			// ✅ Gestione del submit del form
			form.addEventListener('submit', e => {
				form.classList.add('was-validated'); // Attiva lo stile Bootstrap

				let validFields = form.querySelectorAll('*:valid:not(button)'); // Non include il pulsante di submit
				let invalidFields = form.querySelectorAll('*:invalid');

				// Nasconde feedback errore sui campi validi
				validFields.forEach(function (validField) {
					validField.removeAttribute('aria-invalid');
					showHideFeedback(validField, true);
				});

				// Mostra feedback per ogni campo non valido
				invalidFields.forEach(function (invalidField) {
					invalidField.setAttribute('aria-invalid', 'true');
					showHideFeedback(invalidField, false);

					const id = invalidField.getAttribute('id');
					setFeedback(id, invalidField);
				});

				// Blocca invio se il form non è valido
				if (!form.checkValidity()) {
					e.preventDefault();
					e.stopPropagation();
					scrollToFirstErr(); // Scorre al primo errore
				} else {
					showLoading(); // Mostra indicatore di caricamento
				}
			}, false);
		});

		/** ✅
		* Correzione automatica ordine DOM per .form-floating
		* Bootstrap richiede che la <label> sia **dopo** l’elemento input/select/textarea
		* affinché il floating label funzioni correttamente.
		* 
		* Questo script scorre tutti i container con classe `.form-floating`, verifica se
		* la label precede l’input (o select/textarea) e, in tal caso, la sposta subito dopo.
		*/
		document.querySelectorAll('.form-floating').forEach(container => {
			const label = container.querySelector('label');
			const input = container.querySelector('input, select, textarea');
			if (!label || !input) return; // Se manca uno dei due, salta
			// Verifica se la label è posizionata prima dell'input
			const labelIsBeforeInput = (input.compareDocumentPosition(label) & Node.DOCUMENT_POSITION_PRECEDING) !== 0;
			if (labelIsBeforeInput) {
				// Sposta la label dopo l'input
				container.appendChild(label);
			}
		});

		/** ✅
		 * Sposta <label> all'esterno dei container .input-group privi di .form-floating.
		 * Se una <label> si trova all'interno di un .input-group che NON contiene .form-floating,
		 * viene rimossa e posizionata immediatamente prima del gruppo.
		 */
		document.querySelectorAll('.input-group').forEach(group => {
			// Salta se all'interno c'è almeno un .form-floating
			if (group.querySelector('.form-floating')) return;

			// Cerca una <label> direttamente dentro input-group
			const label = group.querySelector('label');
			if (!label) return;

			// Rimuovi la label dal gruppo e inseriscila prima del gruppo
			group.parentNode.insertBefore(label, group);
		});
	}
}

// Show Hide Password // Funzione che mostra o nasconde la password e cambia l'icona corrispondente
export function showHidePassword() {
	// Trova tutti gli elementi con la classe 'btn-show-hide-pwd' (bottoni per mostrare/nascondere la password)
	Array.from(document.querySelectorAll('.btn-show-hide-pwd'))
		.forEach((element) =>
			element.addEventListener('click', (e) => {
				e.preventDefault(); // Previene il comportamento predefinito del bottone (es. submit)

				// Ottiene l'input associato leggendo l'attributo data-rel del bottone
				var rel = document.getElementById(element.dataset.rel);

				// Icona "occhio aperto" (password visibile)
				var eye = element.querySelector('.n');

				// Icona "occhio sbarrato" (password nascosta)
				var eyeSlash = element.querySelector('.y');

				// Se la password è attualmente nascosta, la mostra
				if (rel.type == "password") {
					rel.type = "text"; // Mostra la password
					eye.classList.add('d-none'); // Nasconde l'icona occhio aperto
					eyeSlash.classList.remove('d-none'); // Mostra l'icona occhio sbarrato
				} else {
					// Altrimenti, nasconde la password
					rel.type = "password"; // Nasconde la password
					eye.classList.remove('d-none'); // Mostra l'icona occhio aperto
					eyeSlash.classList.add('d-none'); // Nasconde l'icona occhio sbarrato
				}
			})
		);
}

// Scroll To Element data-anchor // Funzione che esegue uno scroll animato verso un elemento della pagina identificato da un attributo data-anchor
export function scrollToElm(elm, event) {
	// Se presente, impedisce il comportamento predefinito del click (es. evitare che un <a href="#"> ricarichi la pagina)
	if (event) {
		event.preventDefault();
	}
	
	var hh = 0; // Altezza dell'header (se fisso o sticky)
	var header = document.querySelector("header");

	if (header) {
		// Verifica se l'header è fisso o sticky per calcolare lo spazio da sottrarre durante lo scroll
		if (
			header.classList.contains('sticky-top') ||
			header.classList.contains('fixed') ||
			header.classList.contains('is-pinned')
		) {
			hh = header.offsetHeight; // Calcola l'altezza dell'header fisso
		}

		// Chiude il menu hamburger se è attivo (utile per dispositivi mobili)
		const hamburger = document.querySelector('header .hamburger');
		if (hamburger) {
			hamburger.classList.remove('is-active');
		}
		const itemNav = document.querySelector('header .item-nav');
		if (itemNav) {
			itemNav.classList.remove('is-active');
		}

		// Imposta tutti gli elementi con aria-expanded su "false" (per accessibilità)
		document.querySelectorAll('[aria-expanded]').forEach((el) => {
			el.setAttribute('aria-expanded', 'false');
		});
	}

	// Trova il primo elemento con attributo data-anchor uguale al valore passato
	var elmAnchor = document.querySelectorAll("[data-anchor='" + elm + "']")[0];

	if (elmAnchor) {
		// Calcola la distanza dell'elemento dalla parte superiore della viewport
		var elmOffset = elmAnchor.getBoundingClientRect().top;

		// Calcola la posizione finale a cui scrollare, considerando lo scroll attuale e l'altezza dell'header
		var offsetPosition = (elmOffset + window.pageYOffset - hh) - 0;

		// Esegue lo scroll animato verso la posizione calcolata
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}
}

// Check Url Has Hash // Funzione che gestisce il comportamento se l'URL contiene un hash (es. #contatti)
export function urlHasHash() {
	var urlHash = window.location.hash; // Legge l'hash corrente dall'URL (es. "#sezione")

	if (urlHash) {
		// Rimuove il simbolo '#' iniziale per ottenere solo il nome dell'anchor
		urlHash = urlHash.replace(/^#/, '');

		// Cerca il primo elemento che ha data-anchor uguale all'hash
		var elmAnchor = document.querySelectorAll("[data-anchor='" + urlHash + "']")[0];

		// Se l'elemento esiste, esegue lo scroll verso di esso
		if (elmAnchor != undefined) {
			scrollToHash(urlHash); // Funzione esterna che gestisce lo scroll animato
		}
	}

	// Rimuove l'hash dall'URL (mantiene il titolo e la query string, ma senza il #)
	history.pushState("", document.title, window.location.pathname + window.location.search);
}

// Scroll To Hash data-anchor // Funzione che esegue uno scroll animato verso un elemento della pagina identificato da un attributo data-anchor
export function scrollToHash(hash) {

	var hh = 0;
	var header = document.querySelector("header");
	if (header) {
		if (header.classList.contains('sticky-top') || header.classList.contains('fixed') || header.classList.contains('is-pinned')) {
			hh = header.offsetHeight;
		}

		// Chiude il menu hamburger se è attivo (utile per dispositivi mobili)
		const hamburger = document.querySelector('header .hamburger');
		if (hamburger) {
			hamburger.classList.remove('is-active');
		}
		const itemNav = document.querySelector('header .item-nav');
		if (itemNav) {
			itemNav.classList.remove('is-active');
		}

		document.querySelectorAll('[aria-expanded]').forEach((el) => {
			el.setAttribute('aria-expanded', 'false');
		});
	}

	var elmAnchor = document.querySelector("[data-anchor='" + hash + "']");
	if (elmAnchor) {
		var elmOffset = elmAnchor.getBoundingClientRect().top;
		var currentScroll = window.scrollY || window.pageYOffset;
		//console.log('Scroll positions:', { currentScroll, elmOffset, headerHeight: hh });

		var offsetPosition = (elmOffset + currentScroll - hh) - 0;
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	} else {
		console.warn("Elemento con data-anchor='" + hash + "' non trovato");
	}
}

// Scroll To First Error // Funzione che esegue uno scroll animato verso il primo campo non valido del form
export function scrollToFirstErr() {
	var hh = 0;
	var header = document.querySelector("header");
	if (header) {
		// Calcola altezza header se ha classi che ne influenzano il posizionamento
		if (header.classList.contains('sticky-top') || header.classList.contains('fixed') || header.classList.contains('is-pinned')) {
			hh = header.offsetHeight;
		}

		// Chiude il menu hamburger se è attivo (utile per dispositivi mobili)
		const hamburger = document.querySelector('header .hamburger');
		if (hamburger) {
			hamburger.classList.remove('is-active');
		}
		const itemNav = document.querySelector('header .item-nav');
		if (itemNav) {
			itemNav.classList.remove('is-active');
		}

		// Reset aria-expanded su tutti gli elementi
		document.querySelectorAll('[aria-expanded]').forEach((el) => {
			el.setAttribute('aria-expanded', 'false');
		});
	}

	// Trova il primo campo di input non valido (con aria-invalid="true")
	var firstInvalidElement = document.querySelector('input[aria-invalid="true"], select[aria-invalid="true"], textarea[aria-invalid="true"]');
	if (firstInvalidElement) {
		// Calcola posizione verticale corretta considerando offset e header
		var firstInvalidElementOffset = firstInvalidElement.getBoundingClientRect().top;
		var offsetPosition = (firstInvalidElementOffset + window.pageYOffset - hh) - 10;
		// Esegue scroll animato verso la posizione calcolata
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}
}

// Init AOS Animation // Funzione che inizializza AOS (Animate On Scroll) con configurazione personalizzata
export function initAOS() {
	AOS.init({
		// Impostazioni globali
		disable: false, // Disabilita AOS su specifici dispositivi o condizioni
		startEvent: 'DOMContentLoaded', // Evento che avvia l’inizializzazione
		initClassName: 'aos-init', // Classe aggiunta dopo l'inizializzazione
		animatedClassName: 'aos-animate', // Classe aggiunta quando l’elemento viene animato
		useClassNames: false, // Aggiunge data-aos come classe durante lo scroll se true
		disableMutationObserver: false, // Disabilita rilevamento automatico di mutazioni (avanzato)
		debounceDelay: 50, // Ritardo debounce durante il resize (in ms)
		throttleDelay: 99, // Ritardo throttle durante lo scroll (in ms)

		// Impostazioni specifiche per singolo elemento (sovrascrivibili via attributi data-aos)
		offset: 120, // Offset (in pixel) dal punto di trigger
		delay: 0, // Ritardo dell’animazione (0–3000 ms)
		duration: 1000, // Durata dell’animazione (0–3000 ms)
		easing: 'ease', // Tipo di easing predefinito
		once: false, // Se true, l’animazione avviene una sola volta
		mirror: false, // Se true, l’elemento si anima anche in uscita dallo schermo
		anchorPlacement: 'top-bottom', // Posizione dell’elemento rispetto alla finestra che innesca l’animazione
	});
}

// Show / Hide Spinner Element // Funzioni per mostrare o nascondere un indicatore di caricamento (spinner) su un elemento interattivo, disabilitando temporaneamente l'interazione utente sul body durante il caricamento.
export var activeSpinnerElement;
export function showSpinner(elm, text, event) {
	// Previene l'azione predefinita dell'evento (es. submit bottone)
	if (event) {
		event.preventDefault();
	}
	// Memorizza l'elemento corrente con spinner attivo
	activeSpinnerElement = elm;

	// Disabilita l'interazione su tutto il body per evitare input multipli
	const body = document.querySelector('body');
	body.classList.add('pointer-event-none');

	// Disabilita l'elemento specifico e aggiorna attributi ARIA per accessibilità
	const element = elm;
	element.disabled = true;
	element.setAttribute('aria-disabled', 'true');
	element.classList.add('disabled');

	// Mostra lo spinner rimuovendo la classe che lo nasconde
	const spinner = element.querySelector('.spinner-border');
	if (spinner) spinner.classList.remove('d-none');

	// Aggiorna il testo di stato dello spinner (se presente)
	const spinnerStatus = element.querySelector('.spinner-status');
	if (spinnerStatus) spinnerStatus.innerHTML = text;
}
export function hideSpinner(elm, text) {
	// Riabilita l'interazione sul body
	const body = document.querySelector('body');
	body.classList.remove('pointer-event-none');

	// Seleziona l'elemento dal DOM tramite selettore passato
	const element = document.querySelector(elm);
	console.log(element);

	// Riabilita l'elemento e aggiorna attributi ARIA
	element.disabled = false;
	element.setAttribute('aria-disabled', 'false');
	element.classList.remove('disabled');

	// Nasconde lo spinner aggiungendo la classe che lo nasconde
	const spinner = element.querySelector('.spinner-border');
	if (spinner) spinner.classList.add('d-none');

	// Aggiorna il testo di stato dello spinner (se presente)
	const spinnerStatus = element.querySelector('.spinner-status');
	if (spinnerStatus) spinnerStatus.innerHTML = text;
}

// Show Custom Bootstrap Modal // Funzione per mostrare una finestra modale Bootstrap personalizzata con titolo e messaggio dinamici
export function showCustomModal(id, title, message, event) {
	// Previene l'azione predefinita dell'evento (es. click su link o bottone)
	if (event) {
		event.preventDefault();
	}

	// Inserisce il messaggio dinamico nel corpo della modale
	const customModalBody = document.querySelector('#customModalBody');
	customModalBody.innerHTML = message;

	// Inserisce il titolo dinamico nella modale
	const customModalTitle = document.querySelector('#customModalTitle');
	customModalTitle.innerHTML = title;

	// Recupera l'elemento modale tramite id
	var modalID = document.getElementById(id);
	if (!modalID)
		return; // Se non trova la modale, esce senza errori

	// Crea istanza Bootstrap Modal e la mostra
	let customModal = new Modal(modalID);
	customModal.show();
};

// Show Custom YouTube Video Modal Bootstrap // Funzione per mostrare una modale Bootstrap contenente un video YouTube in autoplay, con titolo dinamico
export function showVideoModalYT(id, title, event) {
	const videoModal = document.getElementById('videoModal');
	const videoModalIframe = document.getElementById('videoModalIframe');
	const videoModalLabel = document.getElementById('videoModalLabel');
	if (videoModal) {
		// Crea l'istanza della modale Bootstrap
		const modalVideo = new Modal(videoModal);

		// Crea un iframe per il video YouTube con autoplay e altre proprietà
		const iframe = document.createElement('iframe');
		iframe.width = "560";
		iframe.height = "315";
		iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
		iframe.title = title;
		iframe.frameborder = "0";
		iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
		iframe.allowfullscreen = true;

		// Pulisce il contenuto precedente dell'iframe e aggiunge il nuovo iframe
		videoModalIframe.innerHTML = '';
		videoModalIframe.appendChild(iframe);

		// Imposta il titolo della modale
		videoModalLabel.innerHTML = title;

		// Mostra la modale
		modalVideo.show();

		// Al momento della chiusura della modale, rimuove l'iframe per fermare il video
		videoModal.addEventListener('hidden.bs.modal', event => {
			videoModalIframe.innerHTML = '';
		});
	}
};